// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2NyQn","header":"ClearentDisclaimer_header__yxBLo","inner":"ClearentDisclaimer_inner__EA_AK"};